import { AfterViewInit, Component } from '@angular/core'
import { RuntimeCapabilitiesService } from '@services/runtime-capabilities.service'
import { AuthenticationService } from '@services/authentication.service'
import { RightSidebarService } from '@services/right-sidebar.service'
import { SubscriptionService } from '@services/subscription.service'
import { ToastService } from '@services/toast.service'
import { Stripe } from 'stripe'

@Component({
  selector: 'billing-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css'],
  standalone: false
})
export class MainComponent implements AfterViewInit {
  public isOpening: boolean
  public invoices: Stripe.Invoice[] = []

  get billingPeriodEnd() { return this._subscriptionService.periodEnd }
  get details() { return this._subscriptionService.details }
  get hasUserAdminAccess() { return this._authService.hasUserAdminAccess }
  get inFreeTier() { return this._subscriptionService.inFreeTier }
  get inProTier() { return this._subscriptionService.inProTier }
  get usageStats() {
    const array = []

    if (this._subscriptionService?.usageSummary?.data?.attributes) {
      for (const [key, value] of Object.entries(this._subscriptionService.usageSummary.data.attributes)) {
        array.push(value)
      }
    }

    return array
  }

  constructor(
    private _authService: AuthenticationService,
    private _rightSidebarService: RightSidebarService,
    private _subscriptionService: SubscriptionService,
    private _toastService: ToastService,
    public capabilities: RuntimeCapabilitiesService,
  ) {
    this._subscriptionService.getSubscriptionUsage().subscribe()
    if (this.capabilities.legacyStripe) {
      this._subscriptionService.getInvoices().subscribe(invoices => this.invoices = invoices)
    }
  }

  ngAfterViewInit(): void {
    this._subscriptionService.getSubscriptionDetails().subscribe(details => {
      if (this.capabilities.legacyStripe && details?.status == 'past_due') {
        this.showOverdueToast()
      }
    })
  }

  showOverdueToast() {
    if (!this.capabilities.legacyStripe) return
    this._toastService.toast({
      actionButton: {
        title: "Update Payment Information",
        callback: () => this._subscriptionService.openSubscriptionBillingPortal().subscribe()
      },
      autohide: false,
      color: 'red',
      message: "Payment for your subscription is overdue. Please update your payment information.",
      title: "Action Required",
    })
  }

  openEditSubscriptionPanel() {
    if (!this.capabilities.legacyStripe) return
    this._rightSidebarService.offCanvasReference.offcanvas.show()
  }

  openBillingPortal() {
    if (!this.capabilities.legacyStripe) return
    this.isOpening = true

    this._subscriptionService.openSubscriptionBillingPortal().subscribe(
      () => this.isOpening = false,
      () => this.isOpening = false
    )
  }
}
